import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    current: {},
    list: []
  },
  getters: {
    getEstimateCost (state) {
      return state.current.payItems ? state.current.payItems.filter(p => !p.isTitle || !p.hasChild).reduce((previous, current) =>
        previous + (parseFloat(current.quantity) * parseFloat(current.price)).toFixedNumber(2)
        , 0) : 0
    }
  },
  mutations: {
    setCurrent (state, current) {
      state.current = current
    },
    setList (state, list) {
      state.list = list
    }
  },
  actions: {
    setNewBid ({rootState, commit}) {
      commit('setCurrent', {
        name: '標單名稱',
        price: 0,
        year: new Date().getFullYear() - 1911,
        payItems: []
      })
    },
    async addBid ({rootState, dispatch}, data) {
      const _id = await api.addBid({ name: data.name, price: data.price })
      await dispatch('storeBid', _id)
      await dispatch('storeList')
    },
    async uploadBidPayItems ({ state, dispatch }, file) {
      if (!state.current._id) await dispatch('addBid', state.current)
      await api.uploadBidPayItems(state.current._id, file)
      await dispatch('storeBid', state.current._id)
      await dispatch('storeList')
    },
    async storeBid ({commit}, _id) {
      commit('setCurrent', await api.getBid(_id))
    },
    async storeList ({commit}) {
      commit('setList', await api.getBidList())
    },
    async patchBidPayItems ({state, dispatch}, {bidId, _id, price}) {
      if (!state.current._id) await dispatch('addBid', state.current)
      await api.patchBidPayItems(bidId, _id, price)
    },
    async updateBid ({dispatch, state}, data) {
      return api.updateBid(state.current._id, { name: data.name, price: data.price, year: data.year })
    },
    async deleteBid ({dispatch}, _id) {
      await api.deleteBid(_id)
      await dispatch('storeList')
    },
    async getBidComparison ({dispatch}, _id) {
      return api.getBidComparison(_id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/bid.js